import Header from './components/Header';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Cards from './components/Cards';
import MediaSection from './components/MediaSection';
import Index from './components/Index';
import Contact from './components/Contact';
import Updates from './components/Updates';
import About from './components/About';
import AppSection from './components/AppSection';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <Hero />
        <Carousel />
        <FAQ />
        <Features />
        <Cards />
        <MediaSection />
        <Index />
        <Contact />
        <Updates />
        <About />
        <AppSection />
        <Comments />
        <Ranking />
        <Topics />
      </main>

      <Footer />
    </>
  );
}